$('.company__branch').on("click", ".show-all", function (event) {
    event.preventDefault();
    $('.company__branch__more').toggle();
});


